'use client';

import {applySetLang} from '@wf-components/common-components-consumer';

/**
 * Client-only: applies wf-components `?setlang` rules via {@link initSetLangApply}.
 *
 * Expects a **full** `http:` / `https:` URL. Other inputs are returned unchanged.
 *
 * @param href - Absolute URL string (e.g. from CMS or nav config).
 */
export function applySetLangToHref(href: string): string {
	if (!href.trim() || !window._epicSetLangLocale) {
		return href;
	}

	try {
		const url = new URL(href.trim());
		if (url.protocol === 'http:' || url.protocol === 'https:') {
			return applySetLang(url.href, window._epicSetLangLocale ?? '');
		}
	} catch {
		return href;
	}

	return href;
}
